import { useRef, useEffect } from "react";

const Scrollto = ({ position }) => {
  const myRef = useRef(null);

  useEffect(() => {
    myRef.current?.scrollIntoView("align");
  }, []);

  return (
    <span style={{ position: "relative" }}>
      <div
        style={{
          position: "absolute",
          bottom: position,
        }}
        ref={myRef}
      ></div>
    </span>
  );
};

export default Scrollto;
